import { html, nothing } from 'lit';
import { classMap } from 'lit/directives/class-map.js';
import componentStyles from './checkbox.css.lit.ts';
import { OutlineElement } from '../../base/outline-element/outline-element.ts';
import {ifDefined} from "lit-html/directives/if-defined";

export const checkboxTypeOptions = ['checkbox', 'radio'];

export default class Checkbox extends OutlineElement {
  static styles = [super.styles, componentStyles];
  static get properties() {
    return {
      /**
       * checkbox isChecked manages the checked state
       */
      checked: { type: Boolean },
      /**
       * checkbox label for accessibility
       */
      label: { type: String },
      /**
       * checkbox id
       */
      idKey: { type: String },
      /**
       * checkbox callback on change
       */
      onChange: { type: Function },
      /**
       * checkbox type "checkbox|radio"
       */
      type: { type: String },
      /**
       * checkbox spacing
       */
      spacing: { type: Boolean },
      disabled: { type: Boolean },
      styleclass: { type: String },
    };
  }

  constructor() {
    super();
    this.checked = false;
    this.label = '';
    this.type = 'checkbox';
    this.styleclass = 'default'
  }

  // Supports both clicking of checkbox label and checkbox accessibility box
  _onClick = e => {
    if (!this.disabled) {
      this.checked = !this.checked;
      e.preventDefault()
      this.update();
    } else {
      e.preventDefault()
      e.stopPropagation()
    }
  };

  _renderIcon() {
    if (!this.checked) {
      return nothing;
    }

    if (this.type === 'checkbox') {
      return html`<hf-icon name="checked" class="checkbox__icon"></hf-icon>`;
    }

    return html`<span class="checkbox__icon"></span>`;
  }

  render() {
    return html`
      <div
        class="${classMap({
          'checkbox': true,
          'checkbox--spacing': this.spacing,
          'checkbox--checked': this.checked,
          'checkbox--disabled': this.disabled,
          [`checkbox--${this.styleclass}`]: !!this.styleclass,
        })}"
        @click=${this._onClick}
      >
        <span
          tabindex="0"
          role="checkbox"
          aria-labelledby="checkbox-label"
          aria-checked="${this.checked}"
          class="${classMap({
            'checkbox__box-container': true,
            [`checkbox__box-container--${this.type}`]: this.type,
          })}"
          @click=${this._onClick}
          @keypress=${this._onClick}
        >
          ${this._renderIcon()}
        </span>
        <input
          @click=${this._onClick}
          @change=${this.onChange}
          .checked=${this.checked}
          id=${this.idKey}
          type="${this.type}"
          class="checkbox__input"
          disabled=${ifDefined(this.disabled ? 'disabled' : undefined)}
        />
        <label id="checkbox-label" class="checkbox__label" for="${this.idKey}"
          >${this.label}</label
        >
      </div>
    `;
  }
}

customElements.define('hf-checkbox', Checkbox);
